
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["bell",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 84.57 87.21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Capa 2"}},[_c('g',{attrs:{"data-name":"Capa 1"}},[_c('path',{attrs:{"d":"M17.25 31.71L15.43 42A26.27 26.27 0 012.74 60.19 5.59 5.59 0 004.62 70.5l17.76 3.13v.82a13.12 13.12 0 0025.31 4.46l.3-.76 17.76 3.13A5.58 5.58 0 0071 72.2a26.2 26.2 0 01-5.67-21.36l1.82-10.33a25.3 25.3 0 00-17.89-28.75l-.86-.25 1.65-9.37a1.82 1.82 0 00-3.59-.63l-1.65 9.37-.9-.06a25.29 25.29 0 00-26.66 20.89zm26.49 47a9.45 9.45 0 01-17.56-3.09L26 74.26l18.49 3.26zm2.24-64a21.71 21.71 0 0117.6 25.13l-1.82 10.37a29.87 29.87 0 006.47 24.33 1.94 1.94 0 01-1.83 3.15L5.25 66.91a1.94 1.94 0 01-.64-3.59A29.82 29.82 0 0019 42.67l1.82-10.33A21.72 21.72 0 0146 14.74z"}}),_c('path',{attrs:{"d":"M10.91 28.72a1.75 1.75 0 01-1.42-2A29 29 0 0130.74 3.64 1.75 1.75 0 1131.62 7a25.46 25.46 0 00-18.68 20.3 1.74 1.74 0 01-2 1.42zM7.48 13.6a1.82 1.82 0 01-.55-.2 1.74 1.74 0 01-.67-2.4A29 29 0 0116.56.39a1.75 1.75 0 111.81 3 25.62 25.62 0 00-9.06 9.35 1.75 1.75 0 01-1.83.86zM74.12 39.87a1.75 1.75 0 01-1.42-2A25.48 25.48 0 0062.08 12.4a1.75 1.75 0 012-2.88 29 29 0 0112.07 28.93 1.75 1.75 0 01-2.03 1.42zM82.52 26.83a1.75 1.75 0 01-1.42-1.44 25.69 25.69 0 00-5.32-11.89 1.75 1.75 0 112.72-2.19 29 29 0 016 13.51 1.75 1.75 0 01-1.44 2 1.94 1.94 0 01-.54.01z"}})])])])
          )
        }
      }
    